import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Switch, FormControlLabel, useTheme, alpha } from '@mui/material';
import { BranchedIndicator } from '../BranchedIndicator';
export const PSwitch = ({ label, parentOptionId, parentFieldLabel, parentOptionLabel }) => {
    const theme = useTheme();
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            width: '100%',
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
            borderRadius: '14px',
            background: (theme) => theme.palette.common.grey8,
            minHeight: '53px'
        }, children: [_jsx(FormControlLabel, { control: _jsx(Switch, { size: 'medium', disabled: true }), disabled: true, sx: {
                    flex: 1,
                    minWidth: 0,
                    margin: 0,
                    '& .MuiFormControlLabel-label.Mui-disabled': {
                        color: theme.palette.action.disabled
                    }
                }, label: label, componentsProps: {
                    typography: {
                        sx: {
                            fontSize: '14px',
                            fontWeight: 400,
                            color: theme.palette.text.secondary,
                            pb: 0.5
                        }
                    }
                } }), _jsx(Box, { sx: { mr: 2 }, children: _jsx(BranchedIndicator, { parentOptionId: parentOptionId, parentFieldLabel: parentFieldLabel, parentOptionLabel: parentOptionLabel }) })] }));
};
